module.exports = __webpack_public_path__ + "img/quality.12cf4d13.png";